<template>
  <b-row :id="id">
    <b-col>
      <b-row class="hidden-print" v-show="!isDataLoaded">
        <b-col>
          <b-row>
            <b-col>
              <div class="icons-row pt-2">
                <div v-b-tooltip.hover title="Usunięcie produktu z dostawy" @click="RemoveDelivery(deliveryItem)">
                  <i class="fas fa-trash fa-lg"></i>
                </div>
                <div>
                  <a :href="'#/Dostawa/' + deliveryItem.rawMaterialId" v-b-tooltip.hover title="Edycja dostawy"
                    class="color-black">
                    <i class="fas fa-edit fa-lg"> </i>
                  </a>
                </div>
                <div>
                  <a :href="'#/PodsumowanieDostawyDlaProduktu/' + rawMaterialDetails.id" v-b-tooltip.hover
                    title="Formularz podsumujący dostawę" class="color-black">
                    <i class="far fa-file-pdf fa-lg"> </i>
                  </a>
                </div>
                <div class="float-right pointer color-black" v-b-tooltip.hover title="Strata produktu"
                  v-on:click="OpenModalMaterialLoss(deliveryItem)">
                  <i class="fas fa-minus fa-lg"></i>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <Print :elementToPrintId="id" />
        </b-col>
        <b-col sm="12" md="12">
          <hr />
        </b-col>
      </b-row>

      <div class="row">
        <div class="col-3">
          <b class="pb-2">Dodane:</b>
          <div>
            <div v-b-tooltip.hover title="Data dodania">
              <i class="fas fa-calendar-check"></i>
              {{ deliveryItem.createdDate | moment("DD-MM-YYYY HH:mm") }}
            </div>
            <div v-b-tooltip.hover title="Osoba która dodała">
              <i class="fas fa-user-plus"></i> {{ deliveryItem.createdBy }}
            </div>
          </div>
        </div>

        <div class="col-3">
          <div v-if="deliveryItem.modificationDate">
            <b class="pb-2">Edytowane:</b>
            <div>
              <i class="fas fa-calendar-alt"></i>
              {{ deliveryItem.modificationDate | moment("DD-MM-YYYY HH:mm HH:mm") }}<br />
              <div v-if="deliveryItem.modifiedBy">
                <i class="fas fa-user-edit"></i>
                <span>{{ deliveryItem.modifiedBy }}</span><br />
              </div>
            </div>
          </div>
        </div>
        <div class="col-6" v-show="!isDataLoaded">
          <div class="row">
            <div class="grid-border col-8"> Przyjęta ilość przy dostawie </div>
            <div class="grid-border col-4">{{ roundTo2(rawMaterialDetails.deliveryWeight) }} kg</div>
          </div>
          <div class="row">
            <div class="grid-border col-8"> Wolna ilość na magazynie </div>
            <div class="grid-border col-4">{{ roundTo2(rawMaterialDetails.availableWeight) }} kg</div>
          </div>
          <div class="row">
            <div class="grid-border col-8">Użyta ilość do produkcji </div>
            <div class="grid-border col-4">{{ roundTo2(rawMaterialDetails.usedWeight) }} kg</div>
          </div>
          <div class="row">
            <div class="grid-border col-8"> Materiał stracony </div>
            <div class="grid-border col-4">{{ roundTo2(rawMaterialDetails.materialLoos) }} kg</div>
          </div>
          <div class="row">
            <div class="grid-border col-8"> Cena za kg | Cena za dostawę </div>
            <div class="grid-border col-4">
              {{ rawMaterialDetails.currency === pln ? rawMaterialDetails.pricePerKg : roundTo2(rawMaterialDetails.pricePerKg * rawMaterialDetails.currencyExchange) }} zł | {{roundTo2(rawMaterialDetails.deliveryWeight * rawMaterialDetails.pricePerKg)}} zł
              <div v-if="rawMaterialDetails.currency !== pln"> {{rawMaterialDetails.pricePerKg}} {{currentCurrency}}  </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4 grid-border">Waluta</div>
            <div class="col-4 grid-border">Data kursu</div>
            <div class="col-4 grid-border">Kurs przewalutowania</div>
            <div class="col-4 grid-border">{{ currentCurrency}}</div>
            <div class="col-4 grid-border">{{rawMaterialDetails.currencyExchangeDate ? new Date(rawMaterialDetails.currencyExchangeDate).toLocaleDateString("pl-PL") : "Nie dotyczy"}}</div>
            <div class="col-4 grid-border">{{rawMaterialDetails.currencyExchange ?? "Nie dotyczy"}}</div>
          </div>

        </div>
      </div>


      <Loading v-if="isDataLoaded"></Loading>

      <b-row class="pt-4" v-if="rawMaterialDetails.couvertures != undefined &&
        rawMaterialDetails.couvertures.length > 0
        ">
        <b-col>
          <h4>Surowiec został użyty do produkcji kuwertur:</h4>
          <b-row>
            <b-col class="grid-border py-1" sm="4" md="4"><b>Nazwa </b></b-col>
            <b-col class="grid-border py-1" sm="2" md="2"><b>Waga / Waga początkowa </b></b-col>
            <b-col class="grid-border py-1" sm="2" md="2"><b>Data utworzenia</b></b-col>
            <b-col class="grid-border py-1" sm="2" md="2"><b>Czy na półce </b></b-col>
            <b-col class="grid-border py-1" sm="2" md="2"><b>Data wyjęcia </b></b-col>
          </b-row>
          <b-row v-for="item in rawMaterialDetails.couvertures" :key="item.deliveryId">
            <b-col class="grid-border py-1" sm="4" md="4">
              <a :href="'#/HistoriaKuwertury/' + item.couvertureId" class="color-black">{{ item.couvertureName }}</a>
            </b-col>
            <b-col class="grid-border py-1" sm="2" md="2">{{
              roundTo2(item.usedWeight)}} kg / {{roundTo2(item.rawMaterialInitialWeight) }} kg
            </b-col>
            <b-col class="grid-border py-1" sm="2" md="2">
              {{ item.createDate | moment("DD-MM-YYYY HH:mm") }}</b-col>
            <b-col class="grid-border py-1" sm="2" md="2">{{
              item.isOnShelf ? "Tak" : "Nie"
            }}</b-col>
            <b-col class="grid-border py-1" sm="2" md="2">
              <span v-if="item.endDate">{{ item.endDate | moment("DD-MM-YYYY HH:mm") }}</span>
              <span v-else>-</span>
            </b-col>

            <b-col md="12" sm="12" v-for="coatingProduct in item.coatingProducts" :key="coatingProduct.id">
              <b-row>
                <b-col class="grid-border py-1" offset="1" md="3" sm="3">{{
                  coatingProduct.coatingProductName
                }}</b-col>
                <b-col class="grid-border py-1" md="2" sm="2">{{
                  roundTo2(coatingProduct.usedWeight)
                }} kg</b-col>
                <b-col class="grid-border py-1" md="2" sm="2">
                  {{ coatingProduct.createDate | moment("DD-MM-YYYY HH:mm") }}</b-col>
                <b-col class="grid-border py-1" md="2" sm="2">{{
                  coatingProduct.isOnShelf ? "Tak" : "Nie"
                }}</b-col>
                <b-col class="grid-border py-1" md="2" sm="2">
                  <span v-if="coatingProduct.endDate">{{
                    coatingProduct.endDate | moment("DD-MM-YYYY HH:mm")
                  }}</span>
                  <span v-else>-</span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row class="pt-4" v-if="rawMaterialDetails.coatingProducts != undefined &&
        rawMaterialDetails.coatingProducts.length > 0
        ">
        <b-col>
          <h4>Surowiec został użyty do produkcji oblewanych produktów:</h4>

          <b-row>
            <b-col class="grid-border py-1">Nazwa</b-col>
            <b-col class="grid-border py-1">Waga (kg)</b-col>
            <b-col class="grid-border py-1">Data utworzenia</b-col>
            <b-col class="grid-border py-1">Data wyjęcia</b-col>
            <b-col class="grid-border py-1">Czy na półce</b-col>

          </b-row>
          <b-row v-for="rawMaterial in rawMaterialDetails.coatingProducts" :key="rawMaterial.id">
            <b-col class="grid-border py-1">
              <a :href="'#/HistoriaOblewania/' + rawMaterial.coatingProductId" class="color-black">{{ rawMaterial.name }}</a>
            </b-col>
            <b-col class="grid-border py-1">{{ rawMaterial.avaiableWeight	}}</b-col>
            <b-col class="grid-border py-1">{{
              rawMaterial.createDate | moment("DD-MM-YYYY HH:mm")
            }}</b-col>
            <b-col class="grid-border py-1">
                 <span v-if="rawMaterial.endDate">{{rawMaterial.endDate | moment("DD-MM-YYYY HH:mm")}}</span>
              </b-col>
            <b-col class="grid-border py-1">
                {{rawMaterial.isOnShelf ? "Tak" : "Nie"}}
              </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import Print from "../../Common/Print";
import Loading from "../../Common/Loading";
import FloatHelperMixins from "../../../mixins/floatHelper";
import DeliveryMixins from "../../../mixins/delivery";
import CurrencyMixins from "../../../mixins/currencyMixin";
import toastr from "../../../mixins/toastr";

export default {
  mixins: [FloatHelperMixins, DeliveryMixins,CurrencyMixins, toastr],
  props: ["rawMaterialDetails", "isDataLoaded", "deliveryItem"],
  components: { Print, Loading },
  computed:{
    currentCurrency(){
      return this.rawMaterialDetails.currency
          ? this.currencyList?.filter(x=>x.value === this.rawMaterialDetails.currency)[0].label
          : this.currencyList?.filter(x=>x.value === this.pln)[0].label
    }
  },
  data() {
    return {
      id: this._uid,
    };
  },
  methods: {
    RemoveDelivery(item) {
      var that = this;
      var itemId = item.deliveryId;
      if (
        confirm(
          `Czy napewno chcesz usunąć produkt ${item.rawMaterialTypeName} o numerze ${item.batchNumber}`
        )
      ) {
        this.removeDelivery(itemId)
          .then(function (res) {
            if (res.data.success) {
              that.DisplaySuccess("Sukces!", "Usunięcie dostawy powiodło się")
            } else {
              that.DisplayError('Błąd!', res.data.errors[0]);
            }
            that.$emit("RemoveDeliveryItem", itemId);
          })
          .catch(function (e) {
            console.log(e);
            that.DisplayError("Błąd!", "Usunięcie dostawy nie powiodło się")
          });
      }
    },
    OpenModalMaterialLoss(item) {
      this.$emit("OpenModalMaterialLoss", item);
    },
  },
};
</script>
